/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-magic-numbers */
import React, { useEffect, useState, useMemo, useRef, Children } from 'react'
import { Button, Toast, Popup } from 'antd-mobile'
import styles from './authorize-commom-page.module.scss'
import Header from '@/components/header/header'
import classNames from 'classnames'
import ProductList from '@/components/product-list/product-list'
import productApi, { ProductListResponse, ProductListParams } from '@/apis/product'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { isIOS, isAndroid, isInWeChat, download, Storage } from '@bihu/common-js'
import activityApi from '@/apis/activity'
import copy from 'copy-to-clipboard'
import { UserInfo } from '@/types/apis/user'
import { ENTER_AGREEMENT, TOKEN } from '@/constants/storage'
import indexApi, { FomrSubmitStatusParams } from '@/apis'
import ProtocolIdsConfirm1 from '../protocolIds-confirm-1/protocolIds-confirm-1'
import ProtocolIdsConfirm2 from '../protocolIds-confirm-2/protocolIds-confirm-2'
import useFirstOrAfter from '@/hooks/use-first-or-after'
import ApiToH5Skin from './components/api-to-h5-skin/api-to-h5-skin'
import { selectUserInfo } from '@/store/user'
import { useAppSelector } from '@/store/hooks'
import moment from 'moment'
import indexApiInfo from '@/apis/index'
import InstitutionList from '../institution-list/institution-list'
import { RightOutline } from 'antd-mobile-icons'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { FqlPhoneModel } from '@/constants/common'
import { mergeSerialNoIntoHref, pickSerialNo } from '@/utils/utils'
import {
  AuthorizeSkinContainer,
  type AuthorizeSkinAgreement,
  type AuthorizeSkinProduct,
} from '@/pages/application-flow-skins'
import useAuthorizePresentation from '../../hooks/use-authorize-presentation'
import useV2AuthorizeBusinessBridge from './hooks/use-v2-authorize-business-bridge'
import useSubmitCountdown from '../../hooks/use-submit-countdown'

interface Props{ }

interface ProtocolType {
  id: string,
  name: string | null,
  protocolType: number | null
  partnerProtocolList?:any
}

interface InstitutionProduct {
  id: number,
  productCompany: string | null,
  productName: string | null,
  partnerProtocolList:ProtocolType[] | null
}

const MQPTDC_CHANNEL_CODE = 'mqpTdC'
const MQPTDC_SUBMIT_DELAY_SEC = 3

const Authorize: React.FC<Props> = () => {
  const { channelValue, adChannelCode } = useSelector((state: RootState) => state.channel)
  const ProtocolIdsConfirm1ModalRef: any = useRef()
  const ProtocolIdsConfirm2ModalRef: any = useRef()
  const [search] = useSearchParams()
  const userInfo = useAppSelector(selectUserInfo)

  const [details, setDetails] = useState<any>({})
  const [rqResult, setRqResult] = useState<any>()
  const [otherProtocols, setotherProtocols] = useState<any[]>([])
  const [youqianlaiProtocol, setYouqianlaiProtocol] = useState<any>('')
  const [agreementContent, setAgreementContent] = useState('')
  const [dynamicProtocols, setDynamicProtocols] = useState<ProtocolType[]>([])
  const [previewProtocols, setPreviewProtocols] = useState<ProtocolType[]>([])
  const [dynamicProtocolContents, setDynamicProtocolContents] = useState<Record<string, string>>({})
  // 是否显示弹出层
  const [protocolIdsVisible, setProtocolIdsVisible] = useState(false)
  // 如果是匹配多产品，则显示匹配的多产品协议列表
  const [institutionProtocol, setInstitutionProtocol] = useState<any>([])
  // 多产品树状协议列表下，当前点击的树状节点
  const [checkProtocol, setCheckProtocol] = useState<string>('')
  // 当前勾选的多产品
  const [checkInstitution, setCheckInstitution] = useState<number[]>([])
  // 新增：存储protocolType=11的协议列表
  const [protocolType11Protocols, setProtocolType11Protocols] = useState<any>([])

  const navigate = useNavigate()

  useFirstOrAfter(() => {
    localStorage.removeItem('productBack')
    if (!Storage.get('isRefreshLoadPage') && !search.get('refresh')) {
      Storage.set('isRefreshLoadPage', true)
      // window.location.href = `${document.URL}&refresh=1`
      return
    } else {
      Storage.set('isRefreshLoadPage', false)
    }

    // 监听浏览器回退事件
    window.addEventListener('popstate', back, false)
    // window.onpopstate = back
    window.history.pushState(null, 'null', document.URL)

    return () => {
      // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
      window.removeEventListener('popstate', back, false)
      // window.onpopstate = null
    }
  }, () => {
  // eslint-disable-next-line no-console
  }, [])

  // 打开挽留弹窗
  const openProtocolIdsConfirm1Modal = () => {
    let tempYouqianlaiProtocol = ''
    let temPotherProtocols:any = []
    // eslint-disable-next-line array-callback-return
    rqResult.protocols?.map((item:any) => {
      if (item.protocolType !== 1) {
        temPotherProtocols.push(item)
      } else if (item.protocolType === 1) {
        tempYouqianlaiProtocol = item
      }
    })
    // 新增：将protocolType=11的协议也添加到otherProtocols中，确保在挽留弹窗中显示
    if (protocolType11Protocols && protocolType11Protocols.length > 0) {
      temPotherProtocols = [...temPotherProtocols, ...protocolType11Protocols]
    }

    ProtocolIdsConfirm1ModalRef.current.init({
      quota: details.applyLimit >= 3 ? '100,000' : '50,000',
      productName: rqResult.productName,
      youqianlaiProtocol: tempYouqianlaiProtocol,
      otherProtocols: temPotherProtocols,
      productId: rqResult.id,
      serialNo: getEffectiveSerialNo(),
    })
  }

  // 返回
  const back = () => {
    const isShowPopupStorage = Storage.get('isShowPopup')

    try {
      if (isShowPopupStorage) {
        Storage.set('isShowPopup', false)
        navigate(-1)
      } else {
        //  阻止浏览器回退事件
        openProtocolIdsConfirm1Modal()
        Storage.set('isRefreshLoadPage', false)
        Storage.set('isShowPopup', true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const [token, setToken] = useState('')
  const [apiChannelCode, setApiChannelCode] = useState('')
  const [serialNo, setSerialNo] = useState('')
  const [isSpecialChannel, setIsSpecialChannel] = useState<boolean>(false)
  const [jumpUrl, setJumpUrl] = useState('')
  // 当前操作第几回授权
  const [authNum, setAuthNum] = useState(0)
  let urlRqResult: any = search.get('rqResult')

  const getEffectiveSerialNo = () => pickSerialNo(
    search.get('serialNo'),
    serialNo,
    rqResult?.serialNo
  )

  useEffect(() => {
    let urlApiChannelCode:any = search.get('apiChannelCode')
    let urlSerialNo:any = search.get('serialNo')
    let urlToken:any = search.get('token')
    let urlJumpUrl:any = search.get('jumpUrl')
    //设置authNum
    let urlAuthNum: any = search.get('authNum')
    if (urlAuthNum) {
      setAuthNum(Number(urlAuthNum))
    }
    if (urlApiChannelCode) {
      setSerialNo(urlSerialNo)
      setApiChannelCode(urlApiChannelCode)
      localStorage.setItem('ad_channel_code', urlApiChannelCode)
      if (urlJumpUrl) {
        const tempJumpUrl = JSON.parse(decodeURIComponent(urlJumpUrl))
        setJumpUrl(tempJumpUrl)
      }
      if (urlApiChannelCode === 'kxj01' || urlApiChannelCode === 'kxj02') {
        setIsSpecialChannel(true)
      }
      if (urlToken) {
        Storage.set(TOKEN, urlToken)
        setToken(urlToken)
      }
    } else {
      const pageOptions: any = search.get('options')
      let tempDetails
      let checkProduct
      try {
        tempDetails = JSON.parse(decodeURIComponent(pageOptions)) || {}
      } catch (err) {
        tempDetails = JSON.parse(pageOptions) || {}
      }
      // 如果是多产品分发，那么给产品默认添加勾选
      if (tempDetails.rqResult?.mayAuthProductList?.length > 0) {
        checkProduct = tempDetails.rqResult?.mayAuthProductList?.map((product: InstitutionProduct) => {
          return product.id
        })
        setCheckInstitution(checkProduct)
      }
      setDetails(tempDetails)
      setRqResult(tempDetails.rqResult)
      if (tempDetails.rqResult?.serialNo) {
        setSerialNo(tempDetails.rqResult.serialNo)
      }
    }
  }, [])

  // 应用在API采量授权页重刷的场景
  const reVisitApiAuthPage = () => {
    if (urlRqResult) {
      const tempRqResult = JSON.parse(decodeURIComponent(urlRqResult))
      setRqResult(tempRqResult)
      if (tempRqResult.serialNo) {
        setSerialNo(tempRqResult.serialNo)
      }
      setDetails({
        applyLimit: tempRqResult.applyLimit
      })
    }
  }

  // 如果是麦吉优则修改
  useEffect(() => {
    let newProtocols: any = []
    let ProtocolTreeList: any = []
    let tempProtocolType11Protocols: any = [] // 新增：存储protocolType=11的协议
    const tempDynamicProtocols: ProtocolType[] = []
    const tempPreviewProtocols: ProtocolType[] = []
    // eslint-disable-next-line array-callback-return
    rqResult && rqResult.protocols?.map((item: any, index: number) => {
      if (item.protocolType !== 1) {
        // 新增：过滤掉protocolType=11的协议，避免在弹窗中重复显示
        if (item.protocolType !== 11) {
          newProtocols.push(item)
          ProtocolTreeList.push(item)
        } else {
          tempProtocolType11Protocols.push(item)
          // 顶层非折叠协议同样由后端返回正文，应与主动态协议一起参与新皮肤预览。
          tempPreviewProtocols.push(item)
        }
      } else if (item.protocolType === 1) {
        const dynamicProtocol = { ...item }
        if (channelValue?.includes('mjy') || channelValue?.includes('hbjf')) {
          dynamicProtocol.name = '用户个人信息共享授权协议'
        }
        // 如果是聚客融渠道的联登协议，需要将协议名改为聚客融联登协议
        if (channelValue?.includes('jufu') && dynamicProtocol.name === '有钱来联登默认协议') {
          dynamicProtocol.name = '聚客融联登默认协议'
        }
        tempDynamicProtocols.push(dynamicProtocol)
        tempPreviewProtocols.push(dynamicProtocol)
      }
    })


    // 针对有钱来全流程类型的合作方式，需要把第三方协议并入合作机构协议中展示
    if (rqResult && rqResult.thirdpartyType === 7) {
      if (rqResult.yqlWholeProcessBumpVO && rqResult.yqlWholeProcessBumpVO.partnerProtocolList) {
        // 新增：过滤掉protocolType=11的协议，避免在弹窗中重复显示
        const filteredPartnerProtocols = rqResult.yqlWholeProcessBumpVO.partnerProtocolList.filter((protocol: any) => protocol.protocolType !== 11)

        newProtocols = [
          ...newProtocols,
          ...filteredPartnerProtocols,
        ]
        ProtocolTreeList.push({
          id: Math.random().toString(36),
          name: rqResult.productName || '合作机构协议',
          protocolList: filteredPartnerProtocols,
        })
        // 新增：检查第三方协议中是否有protocolType=11的协议
        rqResult.yqlWholeProcessBumpVO.partnerProtocolList.forEach((protocol: any) => {
          if (protocol.protocolType === 11) {
            tempProtocolType11Protocols.push(protocol)
          }
        })
      }
    }
    // 如果是多产品，那么就将展示多产品形式的树状协议列表
    if (rqResult && rqResult?.mayAuthProductList?.length > 0) {
      rqResult?.mayAuthProductList.forEach((product: InstitutionProduct) => {
        if (product.partnerProtocolList && product.partnerProtocolList?.length > 0) {
          // 新增：过滤掉protocolType=11的协议，避免在弹窗中重复显示
          const filteredProductProtocols = product.partnerProtocolList.filter((protocol: any) => protocol.protocolType !== 11)

          // 新增：检查多产品协议中是否有protocolType=11的协议
          product.partnerProtocolList.forEach((protocol: any) => {
            if (protocol.protocolType === 11) {
              tempProtocolType11Protocols.push(protocol)
            }
          })

          return ProtocolTreeList.push({
            id: product.id,
            name: product.productName,
            protocolList: filteredProductProtocols
          })
        }
      })
    }
    // 聚客融渠道不展示合作机构个人信息授权书
    if (ProtocolTreeList.length > 0 && channelValue?.includes('jufu')) {
      ProtocolTreeList = ProtocolTreeList.filter((item:ProtocolType) => item?.name !== '合作机构个人信息授权书')
      newProtocols = newProtocols.filter((item:ProtocolType) => item?.name !== '合作机构个人信息授权书')
    }
    setInstitutionProtocol(ProtocolTreeList)
    setotherProtocols(newProtocols)
    // 新增：设置protocolType=11的协议列表
    setProtocolType11Protocols(tempProtocolType11Protocols)
    setDynamicProtocols(tempDynamicProtocols)
    setPreviewProtocols(tempPreviewProtocols)
    // 旧皮肤仍使用单份协议正文，继续使用最后一份以保持既有行为；新版皮肤使用完整动态列表。
    setYouqianlaiProtocol(tempDynamicProtocols[tempDynamicProtocols.length - 1] || '')
  }, [channelValue, rqResult])

  useEffect(() => {
    let active = true

    const getAgreementInfos = async() => {
      if (!rqResult?.id || !previewProtocols.length) {
        if (active) {
          setDynamicProtocolContents({})
          setAgreementContent('')
        }
        return
      }

      const useMjyAgreement = channelValue?.includes('mjy') || channelValue?.includes('hbjf')
      const mjyAgreementContent = useMjyAgreement ? await mjyUserAgreement() : ''
      const agreementEntries = await Promise.all(previewProtocols.map(async protocol => {
        try {
          const res: any = await indexApi.getAgreementInfo(protocol.id, rqResult.id, rqResult.serialNo || serialNo)
          let content = res.content || ''

          if (channelValue?.includes('jufu')) {
            const companyName = channelValue?.includes('jfxd') ? '广州市聚富互联网小额贷款有限公司' : '深圳聚客融科技有限公司'
            content = content.replace(/广州虫洞跳跃信息科技有限公司|广州市虫洞科技有限公司/g, companyName)
            if (rqResult.thirdpartyType === 1) {
              content = content.replace(/广州海珠/g, '深圳龙华')
              content = content.replace(/传输给\s*/, '传输给【广州市虫洞科技有限公司】')
            }
          }
          if (channelValue?.includes('jiezhanggui')) {
            content = content.replace(/广州虫洞跳跃信息科技有限公司|广州市虫洞科技有限公司/g, '本平台')
          }
          return [String(protocol.id), useMjyAgreement && protocol.protocolType === 1 ? mjyAgreementContent : content] as const
        } catch {
          return [String(protocol.id), ''] as const
        }
      }))

      if (!active) {
        return
      }
      const contents = Object.fromEntries(agreementEntries)
      const primaryProtocol = dynamicProtocols[dynamicProtocols.length - 1]
      setDynamicProtocolContents(contents)
      // 供旧皮肤及其旧协议弹窗继续消费；新版皮肤按 ID 消费全部正文。
      setAgreementContent(primaryProtocol ? contents[String(primaryProtocol.id)] || '' : '')
    }

    getAgreementInfos()
    return () => {
      active = false
    }
  }, [channelValue, dynamicProtocols, previewProtocols, rqResult, serialNo])

  const toHuiYiHuaPage = (res:any) => {
    if (apiChannelCode) {
      const tempUrl = `/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(res))}&apiChannelCode=${apiChannelCode}&applyLimit=${res.applyLimit}&jumpUrl=${encodeURIComponent(JSON.stringify(jumpUrl))}&serialNo=${serialNo}`
      window.location.replace(tempUrl)
    } else {
      window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(res))}&adChannelCode=${details.adChannelCode}&isHuaWeiPhone=${details.isHuaWeiPhone}&applyLimit=${res.applyLimit}`)
    }
  }

  useEffect(() => {
    async function getFomrSubmitStatus() {
      let submitData:FomrSubmitStatusParams = {
        adChannelCode: apiChannelCode,
        serialNo
      }
      const phoneModel = sessionStorage.getItem('phoneModel')
      if (phoneModel) {
        submitData.phoneModel = phoneModel as FqlPhoneModel
      }
      const res:any = await indexApi.getFomrSubmitStatus(submitData)
      // 如果用户已经授权过，并且第二回授权没有结果，跳转到上回结果页
      if (res.submitStatus === 10 && res.rematchResult !== 3) {
        const reMatchResult:any = res
        let tempOptions:any = {}
        // 否则取上回的结果，跳至下载页
        tempOptions = JSON.parse(JSON.stringify(reMatchResult))
        tempOptions.isNotFormReq = true // 标记为非表单请求方式的跳转
        tempOptions.rePageShowType = 0
        tempOptions.revisit = true // 标记为再访
        window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
        return
      }
      // 判断是否匹配回调类型(如：惠逸花、惠逸花A)
      if (res.thirdpartyType === 5) {
        toHuiYiHuaPage(res)
        return
      }

      setDetails({
        applyLimit: res.applyLimit
      })
      setRqResult(res)
      if (res.serialNo) {
        setSerialNo(res.serialNo)
      }
    }

    // 说明当前路由已被修改，从URl中获取修改后的数据
    if (apiChannelCode && authNum > 0) {
      reVisitApiAuthPage()
    } else if (token && apiChannelCode) {
      getFomrSubmitStatus()
      let devicePlatForm:any = 3
      if (isAndroid) {
        devicePlatForm = 1
      }
      if (isIOS) {
        devicePlatForm = 2
      }
      indexApi.reportPhoneType(devicePlatForm)
    }

  }, [token, apiChannelCode, serialNo])

  // 选择协议
  const [checked, setChecked] = useState(false)

  // 切换选中协议
  const checkedTaggle = () => {
    setChecked(!checked)
  }

  // 按钮loading
  const [btnLoading, setBtnLoading] = useState(false)

  // 跳转页面
  const openOtherView = (url: string) => {
    Storage.set(ENTER_AGREEMENT, true)
    window.location.href = url
  }

  const openAgreementPage = (path: string) => {
    const effectiveSerialNo = getEffectiveSerialNo()
    openOtherView(effectiveSerialNo ? mergeSerialNoIntoHref(path, effectiveSerialNo, false) : path)
  }

  const submitApplication = async(isNeedChecked = true) => {
    try {
      if (!checked && isNeedChecked) {
        // 新增：将protocolType=11的协议也添加到otherProtocols中，确保在协议确认弹窗中显示
        let allOtherProtocols = [...otherProtocols]
        if (protocolType11Protocols && protocolType11Protocols.length > 0) {
          allOtherProtocols = [...allOtherProtocols, ...protocolType11Protocols]
        }

        ProtocolIdsConfirm2ModalRef.current.init({
          youqianlaiProtocol,
          otherProtocols: allOtherProtocols,
          productId: rqResult.id,
          serialNo: getEffectiveSerialNo(),
        })
        return
      }
      let protocolIds = rqResult.protocols?.map((item:any) => {
        return item.id
      })

      // 如果匹配到的是H5产品，则走H5产品的申请、联登流程
      if (rqResult.thirdpartyType === 1) {
        handleH5Product(rqResult.id, 0, protocolIds)
        return
      }
      setBtnLoading(true)
      // 前端日志上报
      const reportParam = `uid:${userInfo?.uid},adChannelCode:${details.adChannelCode || apiChannelCode},event:授权点击`
      indexApi.reportLog(reportParam)
      // 百度埋点-授权
      if (channelValue?.includes('bdVid')) {
        window._agl && window._agl.push(['track', ['success', { t: 5 }]])
      }
      // 信息授权
      const res:any = await indexApi.confirmAuthorize({
        productId: rqResult.id,
        protocolIds,
        agree: true,
        adChannelCode: details.adChannelCode,
        isHuaWeiPhone: details.isHuaWeiPhone,
        apiChannelCode,
        orderNum: authNum, //第几回授权
        serialNo: rqResult.serialNo || serialNo,
        productIds: checkInstitution
      })
      setBtnLoading(false)
      handleAduitSuccess(res)
    } catch (error) {
      setBtnLoading(false)
    }
  }

  // 处理H5产品逻辑
  const handleH5Product = async(productId:any, entranceType:number, protocolIds:any) => {
    // 申请产品
    let applyProductRes:any = await indexApi.applyFor({
      productId,
      entranceType,
      appH5: 2
    })
    console.log('applyProductRes', applyProductRes)
    // 判断是否需要联登
    if (applyProductRes.unionLoginFlag === 1) {
      try {
        const authH5ProductRes:any = await indexApi.authH5Product({
          productId,
          protocolIds: `${protocolIds}${''}`,
          agree: true,
          entranceType,
          appH5: 2
        })
        if (authH5ProductRes) {
          window.location.href = authH5ProductRes
        } else {
          window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({ rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }))}`
        }
      } catch (error) {
        window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({ rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }))}`
      }
    } else {
      window.location.href = applyProductRes.thirdpartyTargetUrl
    }

  }

  // 修改页面url
  const reFreshPageUrl = (newRqResult:any, tempAuthNum: any) => {
    const pageUrl = window.location.origin + window.location.pathname
    let urlOptions = ''
    // 如果是API采量授权方式
    if (apiChannelCode) {
      let modifiedUrl = `${pageUrl}?apiChannelCode=${apiChannelCode}&jumpUrl=${encodeURIComponent(JSON.stringify(jumpUrl))}&authNum=${tempAuthNum}&rqResult=${encodeURIComponent(JSON.stringify(newRqResult))}&serialNo=${serialNo}`
      window.history.replaceState(null, 'null', modifiedUrl)
    } else {
      urlOptions = {
        ...details,
        rqResult: newRqResult,
      }

      window.history.replaceState(null, 'null', `${pageUrl}?options=${encodeURIComponent(JSON.stringify(urlOptions))}&authNum=${tempAuthNum}`)
    }
  }
  // 这里阐述一下，如果撞库通过则有以下三种情况：
  // 撞库通过并且携带jumpUrl，则跳转到jumpUrl指定的页面
  // 如果是APi转H5，则直接跳转第三方链接
  // 如果授权失败，但是返回了下一个产品就重新授权，这里面针对匹配回调类型thirdpartyType === 5进行了单独处理，否则重新匹配进入此页面
  // 如果以上三种情况都不属于，则直接跳转到成功下载页面，成功页面也会进行判断，如果是分期乐渠道，是没有下载按钮的
  const handleAduitSuccess = async(res: any) => {
    // 正常授权且有结果(撞库通过)
    if (res && res.applyStatus !== 2) {
      // 如果url上有携带跳转地址jumpUrl，则跳转
      if (jumpUrl) {
        res.jumpUrl = jumpUrl
        window.location.href = `/fill-information/success-transfer?options=${encodeURIComponent(JSON.stringify(res))}`
        return
      }
      // 如果是API转H5类型，则直接跳转第三方链接
      if (res.thirdpartyType === 4 && res.thirdpartyTargetUrl) {
        await indexApi.apiH5JumpUrlSuccessFlag({
          uid: userInfo?.uid,
          productId: rqResult.id,
          productName: rqResult.productName,
          thirdpartyTargetUrl: res.thirdpartyTargetUrl
        })
        window.location.href = res.thirdpartyTargetUrl
        return
      }

      // 如果授权失败，但是有返回下一个产品，就重新授权
      if (res.applyStatus === 4 && res.productNextMatchDTO) {
        // productNextMatchDTO没有返回serialNo，需要保存
        if (rqResult.serialNo) {
          res.productNextMatchDTO.serialNo = rqResult.serialNo
        }
        // 判断是否匹配回调类型(如：惠逸花、惠逸花A)
        if (res.productNextMatchDTO.thirdpartyType === 5) {
          toHuiYiHuaPage(res.productNextMatchDTO)
          return
        }
        // 如果是其它产品，则更新本页面信息
        setRqResult(res.productNextMatchDTO)
        setAuthNum(res.productNextMatchDTO.orderNum)
        Toast.show('申请名额已满，您的匹配机构已更新，请继续操作')
        reFreshPageUrl(res.productNextMatchDTO, res.productNextMatchDTO.orderNum)
        return
      }

      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify(res))}&isMultiProduct=${checkInstitution.length > 0}`
      return
    }

    // 结果页
    // 走这里说明是重复授权或者授权失败，重复授权也需要判断res
    const options:any = res ? res : { rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }
    window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify(options))}&isMultiProduct=${checkInstitution.length > 0}`
  }
  const handleLoginSuccess = (res:any) => {
    //
  }
  const handelSubmitData = () => {
    setChecked(true)
    submitApplication(false)
  }

  // 弹起协议相关列表
  const openProtocolsPopup = () => {
    setProtocolIdsVisible(true)
  }


  const isMqpTdCChannel = apiChannelCode === MQPTDC_CHANNEL_CODE
  // -1 表示倒计时未初始化，避免初始值 0 被误判为倒计时已结束
  const [mqpTdCBtnCountdown, setMqpTdCBtnCountdown] = useState(-1)
  const [mqpTdCBtnEnabled, setMqpTdCBtnEnabled] = useState(false)
  const mqpTdCAutoSubmittedRef = useRef(false)

  useEffect(() => {
    if (!isMqpTdCChannel) {
      return
    }
    setMqpTdCBtnCountdown(MQPTDC_SUBMIT_DELAY_SEC)
    setMqpTdCBtnEnabled(false)
    mqpTdCAutoSubmittedRef.current = false
  }, [isMqpTdCChannel])

  useEffect(() => {
    if (!isMqpTdCChannel || mqpTdCBtnCountdown <= 0) {
      return
    }
    const t = setTimeout(() => {
      setMqpTdCBtnCountdown(mqpTdCBtnCountdown - 1)
    }, 1000)
    return () => clearTimeout(t)
  }, [isMqpTdCChannel, mqpTdCBtnCountdown])

  useEffect(() => {
    if (!isMqpTdCChannel || mqpTdCBtnCountdown !== 0) {
      return
    }
    setMqpTdCBtnEnabled(true)
  }, [isMqpTdCChannel, mqpTdCBtnCountdown])

  useEffect(() => {
    if (!isMqpTdCChannel || !mqpTdCBtnEnabled || mqpTdCBtnCountdown !== 0 || !rqResult?.id || mqpTdCAutoSubmittedRef.current) {
      return
    }
    mqpTdCAutoSubmittedRef.current = true
    setChecked(true)
    submitApplication(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMqpTdCChannel, mqpTdCBtnEnabled, rqResult?.id])

  const countdownTime = useSubmitCountdown(isMqpTdCChannel)

  const checkOtherProtocols = (item: any) => {
    const effectiveSerialNo = getEffectiveSerialNo()

    if (item.id) {
      const path = `/info-audit-agreement?isShowHeader=true&agreementId=${item.id}&title=${encodeURIComponent(item.name)}&productId=${rqResult.id}`
      openAgreementPage(path)
      return
    }
    if (!item.url) {
      return
    }
    if (!effectiveSerialNo) {
      window.location.href = item.url
      return
    }
    const absolute = /^https?:\/\//i.test(item.url)
    window.location.href = mergeSerialNoIntoHref(item.url, effectiveSerialNo, absolute)
  }

  // 静态麦吉优共享协议
  const mjyUserAgreement = async() => {
    let userName
    let fillInfo = localStorage.getItem('fillInformation')
    if (fillInfo) {
      userName = JSON.parse(fillInfo).realName
    }
    let userLoginInfo: any = await indexApiInfo.getLoginUserInfo()

    const htmlContent = `
      <p style="text-align: center;"><strong>《用户个人信息共享授权协议》</strong></p>
      <p><span style="font-family: 宋体;">《用户个人信息共享授权协议》 (以下简称“本协议”)是由本公司作为个人信息处理者】</span></p>
      <p><span style="font-family: 宋体;">(以下称“我们”)与您所订立的有效合约</span></p>
      <p><strong>【审慎阅读】当您通过本页面使用我们提供的</strong></p>
      <p><strong>【第三方产品推荐】服务时，您的个人信息会进行共享。为了您的合法权益，请您在使用本服务前务必仔细阅读本协议的全部内容(特别是以粗体/下划线标注的内容)。如果您不同意本协议内容，或无法准确理解本协议任何条款的含义，请不要进行确定及后续操作【签约动作】您同意本协议以数据电文形式订立。如您通过网络页面点击“同意或“注册”或“申请”或“接受用户授权协议”(以网页显示为准)，即视为您已阅读理解本协议的全部内容并同意我们出于相关页面所述目的，将您的个人信息提供给为您提供【用户联登撞库】服务的其他个人信息处理者，本协议即生效</strong></p>
      <p><strong>【共享信息】您授权我们将您的</strong></p>
      <p><span style="font-family: 宋体;">手机号：${userLoginInfo.data.mobile}</span></p>
      <p><strong>信息通过【加密通道/文件/接口方式】传输给第三方为您提供</strong><span style="font-family: 宋体;">【用户联登撞库】</span><strong>服务</strong><span style="font-family: 宋体;">。我们会要求该第三方依法使用您的上述信息。</span><strong>如果您不希望向第三方提供上述信息，请勿点击授权。</strong></p>
      <p><strong>您理解，第三方服务由相应的第三方提供并就以上服务及处理您个人信息的安全性独立承担责任。请您在授权同意前，仔细阅读并理解第三方的服务协议与隐私政策。因该第三方服务或其处理您的个人信息产生的纠纷，或第三方服务违反相关法律法规或者协议约定，或您在使用第三方服务过程中遭受了损失，请您与第三方协商解决。</strong></p>
      <p><strong>【争议解决】凡因本协议引起的任何与之有关的争议，首先应由该等争议的相关当事方通过友好协商解决，如无法友好协商解决的，任何一方均可向广州海珠区人民法院提起诉讼。</strong></p>
      <p><span style="font-family: 宋体;">用户姓名:【${userName || ''}】</span></p>
      <p><span style="font-family: 宋体;">用户账号:【${userLoginInfo.data.uid}】</span></p>
      <p><span style="font-family: 宋体;">日期：【${moment().format('YYYY-MM-DD hh:mm:ss')}】</span></p>
    `
    return htmlContent
  }

  const checkFaProtocol = (protocol: any) => {
    if (protocol.protocolList?.length > 0) {
      if (protocol.name === checkProtocol) {
        setCheckProtocol('')
      } else {
        setCheckProtocol(protocol.name)
      }
    } else {
      checkOtherProtocols(protocol)
    }
  }

  // 当多产品分发的产品勾选改变
  const onCheckedChange = (id: number, value: boolean) => {
    // 创建状态的副本
    let newCheckInstitution = [...checkInstitution]
    const index = newCheckInstitution.findIndex(item => item === id)

    if (value) {
      // 如果 value 为 true 且 id 不在数组中，则将 id 添加到数组中
      newCheckInstitution.push(id)
    } else {
      // 如果 value 为 false 且 id 在数组中，则将 id 从数组中移除
      newCheckInstitution.splice(index, 1)
    }
    // 更新状态
    setCheckInstitution(newCheckInstitution)
  }

  const getTextTips = () => {
    switch (true) {
      case channelValue?.includes('hbjf'):
      case channelValue?.includes('mjy'):
        return <img className={styles.textTips} alt="youqianqianbao-prompt" src={require('@imgs/information/text-tips2.png')} />
      case channelValue?.includes('jurongyi'):
        return <img className={styles.textTips} alt="youqianqianbao-prompt" src={require('@imgs/jufu/jurongyi-prompt.png')} />
      case channelValue?.includes('juhaojie'):
        return <img className={styles.textTips} alt="youqianqianbao-prompt" src={require('@imgs/jufu/haier-prompt.png')} />
      case channelValue?.includes('jufu'):
        return <img className={styles.textTips} alt="youqianqianbao-prompt" src={require('@imgs/jufu/prompt.png')} />
      default:
        return <img className={styles.textTips} alt="youqianqianbao-prompt" src={require('@imgs/information/text-tips.png')} />
    }
  }

  const getSubmitBtnCountdownSuffix = () => {
    if (isMqpTdCChannel && mqpTdCBtnCountdown > 0) {
      return `（${mqpTdCBtnCountdown}s）`
    }
    if (!isMqpTdCChannel && countdownTime) {
      return `（${countdownTime}s）`
    }
    return ''
  }

  const renderProtocolsPopup = () => (
    <Popup
      visible={protocolIdsVisible}
      showCloseButton={true}
      bodyStyle={{
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        minHeight: '40vh',
      }}
      onMaskClick={() => {
        setProtocolIdsVisible(false)
      }}
      onClose={() => {
        setProtocolIdsVisible(false)
      }}
    >
      <div className={styles.protcolPopup}>
        <div className={styles.popupTitle}>协议列表</div>
        <div className={styles.protocolIdsBox}>
          {
            rqResult?.mayAuthProductList?.length > 0
              ? institutionProtocol?.map((protocol: any) => (
                <div key={protocol.name}>
                  <div
                    className={styles.protocolIdItem}
                    onClick={() => checkFaProtocol(protocol)}
                  >
                    <div>{ `《${protocol.name}》` }</div>
                    <img className={classNames([styles.arrowBlack, checkProtocol === protocol.name && styles.chooseArrow])} src={require('@imgs/information/arrow-black.png')} />
                  </div>
                  {
                    checkProtocol === protocol.name ? protocol?.protocolList?.map((child:any) => (
                      <div key={child.name} onClick={() => checkOtherProtocols(child)} className={styles.protocolChild}>
                        <span>{child.name}</span>
                        <RightOutline />
                      </div>
                    )) : null
                  }
                </div>
              ))
              : otherProtocols?.map((item: any) => (
                <div
                  className={styles.protocolIdItem}
                  onClick={() => checkOtherProtocols(item)}
                  key={item.name}
                >
                  <div>{ `${item.name}` }</div>
                  <img className={styles.arrowBlack} src={require('@imgs/information/arrow-black.png')} />
                </div>
              ))
          }
        </div>
      </div>
    </Popup>
  )

  // ===== 新皮肤接入 =====
  // 本区块只把现有授权状态和事件投影给展示皮肤；协议、埋点、倒计时、API、Storage 与跳转仍由本旧容器保留。
  // API 采量场景优先使用旧容器已解析的渠道码，避免 Redux 恢复时短暂套用其他渠道主题。
  const presentationChannelCode = details?.adChannelCode || apiChannelCode || adChannelCode || ''
  const authorizePresentation = useAuthorizePresentation(presentationChannelCode)
  const v2Products = useMemo<AuthorizeSkinProduct[]>(() => {
    if (!rqResult?.id) {
      return []
    }

    const wholeProcess = rqResult.thirdpartyType === 7 ? rqResult.yqlWholeProcessBumpVO : undefined
    const primaryProduct: AuthorizeSkinProduct = {
      id: String(rqResult.id),
      name: wholeProcess?.partnerProductName || rqResult.productName || '借款产品',
      companyName: wholeProcess?.partnerCompanyName || rqResult.productCompany || '',
      logo: wholeProcess?.partnerLogo || rqResult.partnerLogo,
      platformName: wholeProcess?.partnerProductName ? rqResult.productName : undefined,
    }
    const existingIds = new Set([primaryProduct.id])
    const extraProducts: InstitutionProduct[] = Array.isArray(rqResult.mayAuthProductList)
      ? rqResult.mayAuthProductList as InstitutionProduct[]
      : []

    return [primaryProduct, ...extraProducts.reduce<AuthorizeSkinProduct[]>((products, product: InstitutionProduct) => {
      const id = String(product.id)
      if (!id || existingIds.has(id)) {
        return products
      }
      existingIds.add(id)
      products.push({
        id,
        name: product.productName || '借款产品',
        companyName: product.productCompany || '',
      })
      return products
    }, [])]
  }, [rqResult])
  const v2AgreementItems = useMemo<AuthorizeSkinAgreement[]>(() => {
    const agreements: AuthorizeSkinAgreement[] = []
    // 后端可返回多份动态协议；每份以 ID 绑定名称、正文和详情入口，不能再只保留循环中的最后一份。
    dynamicProtocols.forEach(protocol => {
      agreements.push({
        key: `dynamic:${protocol.id}`,
        name: protocol.name || '协议内容',
        content: dynamicProtocolContents[String(protocol.id)] || undefined,
      })
    })
    // 后台“合作方协议（非折叠）”对应 protocolType=11，应逐项展示而非收进“机构相关协议”。
    protocolType11Protocols.forEach((protocol: any) => {
      agreements.push({
        key: `protocol:${protocol.id || protocol.name}`,
        name: protocol.name,
        content: dynamicProtocolContents[String(protocol.id)] || undefined,
      })
    })
    if (channelValue?.includes('jufu')) {
      // 固定协议始终排在所有后端动态协议之后，保持新皮肤展示顺序稳定。
      agreements.push({ key: 'general', name: '通用授权协议' })
      agreements.push({ key: 'student', name: '非大学生承诺函' })
    }
    if (otherProtocols.length > 0) {
      // other 点击后打开协议弹窗，无内联内容。
      agreements.push({ key: 'other', name: '机构相关协议' })
    }
    return agreements
  }, [channelValue, dynamicProtocolContents, dynamicProtocols, otherProtocols.length, protocolType11Protocols])
  const handleV2OpenAgreement = (agreementKey: string) => {
    if (agreementKey === 'general') {
      openOtherView(`/jkr-general-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}&company=${rqResult.productCompany || rqResult.yqlWholeProcessBumpVO?.partnerCompanyName || ''}`)
      return
    }
    if (agreementKey === 'student') {
      openOtherView(`/jkr-student-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}`)
      return
    }
    if (agreementKey === 'other') {
      openProtocolsPopup()
      return
    }
    if (agreementKey.startsWith('protocol:')) {
      const protocol = protocolType11Protocols.find((item: any) => `protocol:${item.id || item.name}` === agreementKey)
      if (protocol) {
        checkOtherProtocols(protocol)
      }
      return
    }
    const protocol = dynamicProtocols.find(item => `dynamic:${item.id}` === agreementKey)
    if (!protocol) {
      return
    }
    const path = `/info-audit-agreement?isShowHeader=true&agreementId=${protocol.id}&title=${encodeURIComponent(protocol.name || '')}&productId=${rqResult.id}&protocolType=${channelValue?.includes('mjy') || channelValue?.includes('hbjf') ? 1 : 0}`
    openAgreementPage(path)
  }
  const handleV2ToggleProduct = (productId: string) => {
    const product = rqResult?.mayAuthProductList?.find((item: InstitutionProduct) => String(item.id) === productId)
    if (product) {
      onCheckedChange(product.id, !checkInstitution.includes(product.id))
    }
  }
  const v2BusinessBridge = useV2AuthorizeBusinessBridge({
    onBack: () => navigate(-1),
    onConfirmAgreement: handelSubmitData,
    onOpenAgreement: handleV2OpenAgreement,
    onSubmit: () => submitApplication(true),
    onToggleAgreement: checkedTaggle,
    onToggleProduct: handleV2ToggleProduct,
  })

  if (authorizePresentation === undefined) {
    // 模板配置未落定前不先挂载 v1，避免模板 2~6 用户看到新旧皮肤闪切。
    return <div aria-busy="true" aria-label="页面加载中" className={styles.presentationLoading} role="status" />
  }

  if (authorizePresentation && rqResult?.thirdpartyType === 5) {
    // 匹配回调授权由 /authorize 旧容器承接；在跳转完成前保持加载态，避免模板 2~6 短暂回退 v1。
    return <div aria-busy="true" aria-label="页面加载中" className={styles.presentationLoading} role="status" />
  }

  if (authorizePresentation && rqResult?.thirdpartyType && rqResult.thirdpartyType !== 5) {
    return (
      <>
        <AuthorizeSkinContainer
          model={{
            agreementChecked: checked,
            agreementContent,
            agreements: v2AgreementItems,
            agreementTitle: v2AgreementItems[0]?.name || '协议内容',
            applyLimit: details?.applyLimit || rqResult?.applyLimit,
            hasSelectedProducts: v2Products.length > 0,
            productSelectionEnabled: Boolean(rqResult?.mayAuthProductList?.length),
            products: v2Products,
            selectedProductIds: [String(rqResult.id), ...checkInstitution.map(id => String(id))],
            submitDisabled: (isMqpTdCChannel && !mqpTdCBtnEnabled) || (!isMqpTdCChannel && Boolean(countdownTime)),
            submitLabel: `立即领取额度${getSubmitBtnCountdownSuffix()}`,
            submitting: btnLoading,
          }}
          onBack={v2BusinessBridge.onBack}
          onConfirmAgreement={v2BusinessBridge.onConfirmAgreement}
          onOpenAgreement={v2BusinessBridge.onOpenAgreement}
          onSubmit={v2BusinessBridge.onSubmit}
          onToggleAgreement={v2BusinessBridge.onToggleAgreement}
          onToggleProduct={v2BusinessBridge.onToggleProduct}
          theme={authorizePresentation.theme}
        />
        {renderProtocolsPopup()}
      </>
    )
  }

  return (
    <section className={styles.authorizePage}>
      <Header />
      <div>
        {
          rqResult?.thirdpartyType && rqResult?.thirdpartyType !== 5 ? <>
            {
              apiChannelCode ? <>
                <ApiToH5Skin
                  rqResult={rqResult ? rqResult : {}}
                  agreementContent={agreementContent}
                  youqianlaiProtocolName={youqianlaiProtocol?.name}
                  isSpecialChannel={isSpecialChannel}
                  isMqpTdCChannel={isMqpTdCChannel}
                />
              </> : <>
                {
                  rqResult?.thirdpartyType && <div>
                    <div className={styles.headerBox}>
                      {
                        getTextTips()
                      }
                    </div>
                    <div className={styles.mainContent}>
                      <div className={styles.limitBox}>
                        <div className={styles.limitBoxTitle}>最高可借额度（元）</div>
                        <div className={styles.limitNum}>{ details?.applyLimit >= 3 ? '100,000' : '50,000'}</div>
                        <div className={styles.splitLine}></div>
                        <div className={styles.limitBoxFooter}>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-1.png')} />
                            <span>年化利率7.2%-24%</span>
                          </div>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-2.png')} />
                            <span>随时可还款</span>
                          </div>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-3.png')} />
                            <span>额度灵活</span>
                          </div>
                        </div>
                      </div>
                      <InstitutionList rqResult={rqResult} onCheckedChange={onCheckedChange} checkInstitution={checkInstitution}></InstitutionList>
                      <div className={styles.protocolBox}>
                        <div className={styles.specialTips}>
                          特别提示：我们会根据您的资质，为您匹配专业的贷款咨询服务机构，请您查阅《个人信息共享授权协议》
                        </div>
                        <div className={styles.protocolBoxContent}>
                          <div className={styles.protocolBoxTitle}>{youqianlaiProtocol.name}</div>
                          <div dangerouslySetInnerHTML={{ __html: agreementContent }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </>
            }
            <div className={styles.footerBox}>
              <div className={styles.footerText}>
                {
                  isMqpTdCChannel ? <>
                    <div>
                      <span>我已同意并签署</span>
                      {
                        rqResult.thirdpartyType !== 1 && channelValue?.includes('jufu')
                          ? <>
                            <span
                              className={styles.footerTextRed}
                              onClick={() => {
                                openOtherView(`/jkr-general-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}&company=${rqResult.productCompany || rqResult.yqlWholeProcessBumpVO.partnerCompanyName}`)
                              }}
                            >
                              《通用授权协议》
                            </span>
                            <span
                              className={styles.footerTextRed}
                              onClick={() => {
                                openOtherView(`/jkr-student-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}`)
                              }}
                            >
                              《非大学生承诺函》
                            </span>
                            {protocolType11Protocols.map((protocol: any, index: number) => (
                              <span
                                key={protocol.id || index}
                                className={styles.footerTextRed}
                                onClick={() => {
                                  checkOtherProtocols(protocol)
                                }}
                              >
                                《{protocol.name}》
                              </span>
                            ))}
                          </>
                          : <span
                            className={styles.footerTextRed}
                            onClick={() => {
                              const path = `/info-audit-agreement?isShowHeader=true&agreementId=${youqianlaiProtocol.id}&title=${encodeURIComponent(youqianlaiProtocol.name)}&productId=${rqResult.id}&protocolType=${channelValue?.includes('mjy') || channelValue?.includes('hbjf') ? 1 : 0}`
                              openAgreementPage(path)
                            }}
                          >
                            《{youqianlaiProtocol.name}》
                          </span>
                      }
                      {
                        otherProtocols.length > 0 && <span
                          className={styles.footerTextRed}
                          onClick={() => {
                            openProtocolsPopup()
                          }}
                        >
                          《机构相关协议》
                        </span>
                      }
                    </div>
                  </> : <>
                    {
                      checked ? <>
                        {
                          channelValue?.includes('jufu')
                            ? <img onClick={checkedTaggle} alt="checked" className={styles.checkedIcon} src={require('@imgs/jufu/checked.png')} />
                            : <img onClick={checkedTaggle} alt="checked" className={styles.checkedIcon} src={require('@imgs/information/checked.png')} />
                        }
                      </> : <>
                        <div className={classNames(styles.checked)} onClick={checkedTaggle}></div>
                      </>
                    }
                    <div>
                      <span onClick={checkedTaggle}>同意并签署</span>
                      {/* 聚客融渠道不需要展示个人协议，需要展示通用授权协议和非大学生承诺函 */}
                      {/* 如果是h5类型，则展示联登协议，联登协议是后台返回 */}
                      {
                        rqResult.thirdpartyType !== 1 && channelValue?.includes('jufu')
                          ? <>
                            <span
                              className={styles.footerTextRed}
                              onClick={() => {
                                openOtherView(`/jkr-general-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}&company=${rqResult.productCompany || rqResult.yqlWholeProcessBumpVO.partnerCompanyName}`)
                              }}
                            >
                              《通用授权协议》
                            </span>
                            <span
                              className={styles.footerTextRed}
                              onClick={() => {
                                openOtherView(`/jkr-student-agreement?isShowHeader=true&useInfo=${JSON.stringify(userInfo)}`)
                              }}
                            >
                              《非大学生承诺函》
                            </span>
                            {/* 新增：显示protocolType=11的协议 */}
                            {protocolType11Protocols.map((protocol: any, index: number) => (
                              <span
                                key={protocol.id || index}
                                className={styles.footerTextRed}
                                onClick={() => {
                                  checkOtherProtocols(protocol)
                                }}
                              >
                                《{protocol.name}》
                              </span>
                            ))}
                          </>
                          : <span
                            className={styles.footerTextRed}
                            onClick={() => {
                              const path = `/info-audit-agreement?isShowHeader=true&agreementId=${youqianlaiProtocol.id}&title=${encodeURIComponent(youqianlaiProtocol.name)}&productId=${rqResult.id}&protocolType=${channelValue?.includes('mjy') || channelValue?.includes('hbjf') ? 1 : 0}`
                              openAgreementPage(path)
                            }}
                          >
                            《{youqianlaiProtocol.name}》
                          </span>
                      }

                      {/* 聚客融-快手需要屏蔽掉匹配机构的协议 */}
                      {
                        otherProtocols.length > 0 && <span
                          className={styles.footerTextRed}
                          onClick={() => {
                            openProtocolsPopup()
                          }}
                        >
                          《机构相关协议》
                        </span>
                      }
                    </div>
                  </>
                }
              </div>
              <div className={styles.btnBox}>
                <Button
                  block
                  loading={btnLoading}
                  loadingText="请等待机构申请结果"
                  className={classNames(
                    styles.btn,
                    isMqpTdCChannel && styles.btnMqpTdC,
                    isMqpTdCChannel && !mqpTdCBtnEnabled && styles.btnMqpTdCDisabled,
                  )}
                  shape="rounded"
                  color="primary"
                  disabled={isMqpTdCChannel && !mqpTdCBtnEnabled}
                  onClick={() => submitApplication(!isMqpTdCChannel)}
                >
                  { `立即领取额度${getSubmitBtnCountdownSuffix()}`}
                </Button>
              </div>
              <div className={styles.paddingBox}></div>
            </div>
          </> : <>
            <div id="root">
              <div id="loading-box">
                <div className={styles.ballClipRotateMultiple}>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </>
        }
      </div>

      <Popup
        visible={protocolIdsVisible}
        showCloseButton={true}
        bodyStyle={{
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          minHeight: '40vh',
        }}
        onMaskClick={() => {
          setProtocolIdsVisible(false)
        }}
        onClose={() => {
          setProtocolIdsVisible(false)
        }}
      >
        <div className={styles.protcolPopup}>
          <div className={styles.popupTitle}>协议列表</div>
          <div className={styles.protocolIdsBox}>
            {
              rqResult?.mayAuthProductList?.length > 0
              // 如果是多产品分发，则显示树状协议列表
                ? institutionProtocol?.map((protocol: any) => {
                  return <div key={protocol.name}>
                    <div
                      className={styles.protocolIdItem}
                      onClick={() => checkFaProtocol(protocol)}
                    >
                      <div>{ `《${protocol.name}》` }</div>
                      <img className={classNames([styles.arrowBlack, checkProtocol === protocol.name && styles.chooseArrow])} src={require('@imgs/information/arrow-black.png')} />
                    </div>
                    {
                      checkProtocol === protocol.name ? protocol?.protocolList?.map((child:any) => {
                        return <div key={child.name} onClick={() => checkOtherProtocols(child)} className={styles.protocolChild}>
                          <span>{child.name}</span>
                          <RightOutline />
                        </div>
                      }) : <></>
                    }
                  </div>
                })
                : otherProtocols?.map((item: any) => {
                  return (
                    <div
                      className={styles.protocolIdItem}
                      onClick={() => checkOtherProtocols(item)}
                      key={item.name}
                    >
                      <div>{ `${item.name}` }</div>
                      <img className={styles.arrowBlack} src={require('@imgs/information/arrow-black.png')} />
                    </div>
                  )
                })
            }
          </div>
        </div>
      </Popup>

      {/* 挽留弹窗 */}
      <ProtocolIdsConfirm1
        ref={ProtocolIdsConfirm1ModalRef}
        onSuccess={(e:any) => handleLoginSuccess(e)}
        openProtocolsPopup={() => openProtocolsPopup()}
        submit={() => handelSubmitData()}/>

      {/* 同意协议弹窗 */}
      <ProtocolIdsConfirm2
        ref={ProtocolIdsConfirm2ModalRef}
        onSuccess={(e: any) => handleLoginSuccess(e)}
        rqResult={rqResult}
        openProtocolsPopup={() => openProtocolsPopup()}
        submit={() => handelSubmitData()}/>

    </section>
  )
}

export default Authorize
